module.exports = __webpack_public_path__ + "img/img_sg.166cbbd0.png";